import { ContactFormData } from '@upright/common/activities/contact-forms/facade/contact-form';
import { useToggleContactModal } from '@upright/ui/common/activities/contact-and-feedback/use-toggle-contact-modal';
import { getBouLinkStyle } from '@upright/ui/common/generic/content/texts/bou-link';
import { ReactNode } from 'react';
import styled from 'styled-components';

export const ContactModalLink = (props: { children: ReactNode; initialValues?: Partial<ContactFormData> }) => {
  const toggleContactModal = useToggleContactModal();
  return (
    <InlineButtonLink
      onClick={() => {
        toggleContactModal(props.initialValues);
      }}
    >
      {props.children}
    </InlineButtonLink>
  );
};
const InlineButtonLink = styled.a`
  all: unset;
  ${getBouLinkStyle(true)}
`;
